<script>
    // https://svelte.dev/docs#createEventDispatcher
    import { createEventDispatcher } from "svelte";
    const dispatch = createEventDispatcher();

    import Supplement from "./Supplement.svelte";
    export let supplements;
    export let supplement_group = -1;

    function needsUpdate() {
        supplements = supplements;
    }
    function supplementIncrement(supplement) {
        dispatch("supplementIncrement", supplement);
        needsUpdate();
    }
    function supplementDecrement(supplement) {
        dispatch("supplementDecrement", supplement);
        needsUpdate();
    }
</script>

<div class="supplements">
        {#each supplements as supplement}
            {#if supplement.group == supplement_group}
                    <Supplement
                        {supplement}
                        isChecked={true}
                        on:increment={(ev) => supplementIncrement(ev.detail)}
                        on:decrement={(ev) => supplementDecrement(ev.detail)}
                    />
            {/if}
        {:else}
            <p>loading...</p>
        {/each}
</div>
